import { useOrbit } from 'providers/OrbitProvider'
import Dropdown from 'components/UI/Dropdown'
import COLORS from 'lib/colors'
import { ClientRecord, ContractRecord, VendorRecord } from 'lib/DataModel'

import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'
import { useCallback, useMemo } from 'react'

function SectionHeading({entities, renderItem, currentEntity, setCurrentEntity, title, isBold}) {
  return (
    (entities && entities.length > 1) ? (
      <Dropdown
        variant="flat"
        collection={entities}
        renderItem={renderItem}
        item={currentEntity}
        setItem={setCurrentEntity}
        aria-label={title}
        sx={{
          fontSize: 14,
          color: COLORS.slateGray,
          fontWeight: isBold ? 700 : undefined,
          '.MuiSelect-icon': {
            color: COLORS.slateGray,
          }
        }}
      />
    ) : (entities && entities.length === 1) ? (
      <Box sx={{ pb: isBold ? undefined : '5px', fontWeight: isBold ? 700 : undefined }}>
        {renderItem(currentEntity)}
      </Box>
    ) : (
      <Box sx={{ pb: '5px' }}>
        {title}
      </Box>
    )
  )
}

export default function TabSectionHeading({ title, entities, currentEntity, setCurrentEntity, entityType }) {
  const { store } = useOrbit()
  const renderItem = useCallback((entity: ClientRecord | VendorRecord | ContractRecord) => {
    if(entity.type === 'contract') {
      const client = store.cache.query(q => q.findRelatedRecord(entity, 'client')) as ClientRecord
      return client?.attributes?.internalName || client?.attributes?.name || '{Client Name}'
    } else if (entity.type === 'client') {
      return entity.attributes.internalName || entity.attributes.name || '{Client Name}'
    } else {
      return entity.attributes.name || '{Vendor Name}'
    }
  }, [store])

  const sortedEntities = useMemo(() => {
    if (!entities || !Array.isArray(entities)) return []

    return [...entities].sort((a, b) => {
      const aKey = renderItem(a)?.toLowerCase?.() || ''
      const bKey = renderItem(b)?.toLowerCase?.() || ''
      return aKey.localeCompare(bKey)
    })
  }, [entities, renderItem])

  const isVendor = entityType === "vendor"
  const isContract = entityType === "contract"

  return (
    <Box sx={{ px: 3, fontSize: 14, color: COLORS.slateGray }}>
      <Box sx={{ px: 3, mt: isContract ? undefined : '16px' }}>
        <SectionHeading
          entities={sortedEntities}
          renderItem={renderItem}
          currentEntity={currentEntity}
          setCurrentEntity={setCurrentEntity}
          title={title}
          isBold={isVendor}
        />
      </Box>
      {!isVendor && <Divider light/>}
    </Box>
  )
}
